import React from "react";

interface LoadingDotsProps {
  className?: string;
}

export const LoadingDots: React.FC<LoadingDotsProps> = ({ className = "" }) => {
  return (
    <span className={`inline-flex gap-[2px] ${className}`}>
      <span className="animate-dot-1 inline-block">.</span>
      <span className="animate-dot-2 inline-block">.</span>
      <span className="animate-dot-3 inline-block">.</span>
    </span>
  );
};
